// @/config/role-config.ts
// 当前用户角色下的显示角色配置项

import config from '@/config/user.env';
import { Store } from 'vuex';

/* 定义角色配置项的类型 */
export interface RoleConfigItem {
  code: string;
  name: string;
  logo: string;
  title: string;
  showInHeader: boolean; // 是否显示在头部
  showInSider: boolean; // 是否显示在侧边栏
  textStyle?: {
    fontFamily: string;
    fontWeight: string;
    fontSize: string;
  };
}

/* 定义角色配置对象类型 */
type RoleConfig = Record<string, RoleConfigItem>;

/* 配置实现 */
// 配置项的 key 为角色编码，value 为角色配置项
// 注意：为了保持代码的健壮性，在构建 roleConfig 对象时，先判断 config 中对应的角色代码是否存在且非空，然后再将其添加到 roleConfig 中
export const roleConfig: RoleConfig = {
  ...(config.roleCode_EL_Line_Planner && {
    [config.roleCode_EL_Line_Planner]: {
      code: config.roleCode_EL_Line_Planner,
      name: 'EL-线路规划岗',
      logo: new URL('@/assets/icon-IRP-system.png', import.meta.url).href,
      title: '智能线路规划系统',
      showInHeader: false,
      showInSider: true,
    },
  }),
  ...(config.roleCode_EL_Order_Clerk && {
    [config.roleCode_EL_Order_Clerk]: {
      code: config.roleCode_EL_Order_Clerk,
      name: 'EL-订单员',
      logo: new URL('@/assets/icon-DO-system.png', import.meta.url).href,
      title: '送装运作系统',
      showInHeader: false,
      showInSider: false, //true
    },
  }),
  ...(config.roleCode_EL_Dispatcher && {
    [config.roleCode_EL_Dispatcher]: {
      code: config.roleCode_EL_Dispatcher,
      name: 'EL-调度员',
      logo: new URL('@/assets/icon-dispatch-system.png', import.meta.url).href,
      title: '调度系统',
      showInHeader: false,
      showInSider: false, //true
    },
  }),
  ...(config.roleCode_EL_Dispatcher_Phase_II && {
    [config.roleCode_EL_Dispatcher_Phase_II]: {
      code: config.roleCode_EL_Dispatcher_Phase_II,
      name: 'EL-调度员二期',
      logo: new URL('@/assets/icon-dispatch-system.png', import.meta.url).href,
      title: '调度系统',
      showInHeader: false,
      showInSider: false, //true
    },
  }),
  ...(config.roleCode_EL_Warehouse_Admin_HQ && {
    [config.roleCode_EL_Warehouse_Admin_HQ]: {
      code: config.roleCode_EL_Warehouse_Admin_HQ,
      name: 'EL-仓储资源管理员-总部',
      logo: new URL('@/assets/icon-SR-system.png', import.meta.url).href,
      title: '安得资源管理平台',
      showInHeader: true,
      showInSider: false,
      textStyle: {
        fontFamily: '华文楷体',
        fontWeight: 'bold',
        fontSize: '20px',
      },
    },
  }),
  ...(config.roleCode_EL_Warehouse_Admin_BRANCH && {
    [config.roleCode_EL_Warehouse_Admin_BRANCH]: {
      code: config.roleCode_EL_Warehouse_Admin_BRANCH,
      name: 'EL-仓储资源管理员-分公司',
      logo: new URL('@/assets/icon-SR-system.png', import.meta.url).href,
      title: '安得资源管理平台',
      showInHeader: true,
      showInSider: false,
      textStyle: {
        fontFamily: '华文楷体',
        fontWeight: 'bold',
        fontSize: '20px',
      },
    },
  }),
  ...(config.roleCode_EL_Cost_Manager && {
    [config.roleCode_EL_Cost_Manager]: {
      code: config.roleCode_EL_Cost_Manager,
      name: 'EL-成本管理员',
      logo: new URL('@/assets/icon-CM-system.png', import.meta.url).href,
      title: '配装成本管理平台',
      showInHeader: false,
      showInSider: true,
    },
  }),
  ...(config.roleCode_ELS_Warehouse_Manager && {
    [config.roleCode_ELS_Warehouse_Manager]: {
      code: config.roleCode_ELS_Warehouse_Manager,
      name: 'EL-供应商', //EL-供应商组下的'ELS-仓储管理'
      logo: new URL('@/assets/icon-SR-system.png', import.meta.url).href,
      title: '安得资源管理平台',
      showInHeader: true,
      showInSider: false,
      textStyle: {
        fontFamily: '华文楷体',
        fontWeight: 'bold',
        fontSize: '20px',
      },
    },
  }),
  default: {
    code: '',
    name: '',
    logo: '',
    title: '数字化运营平台',
    showInHeader: false,
    showInSider: false,
  },

};

/* 提供获取配置的工具函数 */
/**
 * 根据store 实例 获取配置项
 * @param store - Vuex store 实例，用于动态读取状态
 * @returns RoleConfigItem 配置对象
 */
export function getConfig(store: Store<any>): RoleConfigItem {
  // 获取当前角色
  if (store) {
    const { curRole, roleList } = store.state;
    // 供应商组存在多个角色code
    if ( curRole && curRole.trim() !== '' && curRole.split(',').length > 1) {
        // 供应商多个角色下含有ELS-仓储管理特殊处理
        if (curRole.includes(config.roleCode_ELS_Warehouse_Manager)) {
          if (config.roleCode_ELS_Warehouse_Manager){
            return roleConfig[config.roleCode_ELS_Warehouse_Manager] || roleConfig.default;
          }
        }
        const roleItem = roleList.find((item: { roleCode: any }) => item.roleCode === curRole);
        if (roleItem) {
          let roleConfigItem:RoleConfigItem = {
            code: curRole,
            name: roleItem.roleName,
            logo: '',
            title: '数字化运营平台',
            showInHeader: false,
            showInSider: false,
          };
          return roleConfigItem;
        }
    }
    return roleConfig[curRole] || roleConfig.default;
  }else{
    return roleConfig.default;
  }
}